import { useCallback } from "react";
import { App } from "antd";
import { useTranslate } from "@refinedev/core";
import { Button } from "@libertify/ui";
import { useActiveExport } from "pages/media/organizations/hooks/useActiveExport";
import type { BundleResponse } from "@/types";

export const ExportPollingManager = () => {
  const t = useTranslate();
  // App.useApp().notification (not the static `notification` import) so the
  // toast and its children inherit ConfigProvider — keeps the libertify Button
  // on theme tokens (e.g. coral primary) instead of antd's default blue.
  const { notification } = App.useApp();

  const handleTerminalTransition = useCallback(
    (bundle: BundleResponse) => {
      if (bundle.status !== "Completed" || !bundle.download_url) return;
      notification.success({
        message: t("media.organizations.dataExport.toast.readyTitle"),
        description: (
          <Button
            variant="primary"
            onClick={() =>
              window.open(bundle.download_url!, "_blank", "noopener,noreferrer")
            }
          >
            {t("media.organizations.dataExport.download")}
          </Button>
        ),
        placement: "bottomLeft",
        duration: 0,
        role: "status",
      });
    },
    [notification, t]
  );

  useActiveExport({ onTerminalTransition: handleTerminalTransition });

  return null;
};
